module.exports = __webpack_public_path__ + "img/1482498490.dde5eaa0.jpg";